import { Component, Input } from '@angular/core';
import type { State } from '@core/jss-routing';
import { InnogyComponentRendering } from '@core/jss-models';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import {
  getBlogNodeNavigationMain,
  hasSubcategories,
  hasArticles,
} from '../+state/blog.selector';

@Component({
  selector: 'wl-category-navigation',
  templateUrl: './category-navigation.component.html',
  styleUrls: [],
})
export class CategoryNavigationComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  main$ = this.store$.pipe(getBlogNodeNavigationMain);
  hasSubcategoryFilter$ = this.store$.pipe(hasSubcategories);
  private readonly hasArticles$ = this.store$.pipe(hasArticles);
  hasSubcategoriesOrNoArticles$ = this.hasSubcategoryFilter$.pipe(
    withLatestFrom(this.hasArticles$),
    map(([hasSubCategories, hasArticle]) => !hasArticle || hasSubCategories)
  );

  constructor(private readonly store$: Store<State>) {}
}
